import * as XLSX from 'xlsx';

export const exportToExcel = (data, fileName) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

    XLSX.writeFile(workbook, fileName);
};

export const importFromExcel = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
        try {
            const data = new Uint8Array(event.target.result);

            const workbook = XLSX.read(data, {
            type: 'array',
            });

            const firstSheetName = workbook.SheetNames[0];

            if (!firstSheetName) {
            reject(new Error('Excel file does not contain a worksheet.'));
            return;
            }

            const worksheet = workbook.Sheets[firstSheetName];

            const rows = XLSX.utils.sheet_to_json(worksheet, {
            defval: '',
            raw: false,
            });

            resolve(rows);
        } catch (error) {
            reject(new Error('Unable to read Excel file.'));
        }
        };

        reader.onerror = () => {
        reject(new Error('Unable to read Excel file.'));
        };

        reader.readAsArrayBuffer(file);
    });
}